define('views/modules/calendar/animated-session/exercise/weight/weight-content',[
    // Libs
    'underscore', 'backbone', 'mustache', 'utils',
    // Views
    'views/parts/menu/menu',
    'views/modules/calendar/animated-session/exercise/weight/weight-header',
    'views/modules/calendar/animated-session/exercise/weight/weight-week',
    // Templates Blocks
    'text!templates/modules/calendar/animated-session/exercise/weight/weight-content.html',
    'text!templates/modules/calendar/animated-session/exercise/exercise-menu-item.html'
], function(
    // Libs
    _, Backbone, Mustache, U,
    // Views
    VMenu,
    VWeightExerciseHeader,
    VWeightExerciseWeek,
    // Template
    TWeightExerciseContent,
    TExerciseMenuItem
) {

    var VWeightExerciseContent = Backbone.Epoxy.View.extend({
        headerView: VWeightExerciseHeader,
        weekView: VWeightExerciseWeek,
        template: TWeightExerciseContent,

        regions: {
            menu: ".menu-actions",
            list: ".exercise-weight-table",
        },

        initialize: function(opt) {
            opt = this.options = _.extend({}, opt);

            var model = this.model,
                item = this.item = opt.item,
                collection = this.collection = model.getWeeks();

            this.actionItems = new Backbone.Collection([
                { id: 'notes', title: 'messages:tooltip-notes', callback: this.onToggleNoteAction, toggle: true, icon: 'sl-icon-note', },
                // { id: 'convertToCardio', title: 'calendar:Convert this exercise to cardio', callback: this.onConvertToCardioAction, icon: 'fa fa-bar-chart', },
                { id: 'multiReps', title: 'messages:tooltip-multi-reps', callback: this.onToggleMultiRepsAction, toggle: true, active: model.hasMultiRep(), icon: 'fa fa-indent', },
                { id: 'loadEnabled', title: 'messages:tooltip-toggle-load-column', callback: this.onToggleLoadColumnAction, toggle: true, active: model.hasLoadData() || model.hasLoadEnabled(), icon: 'fa fa-balance-scale', },
                { id: 'applyFirstWeek', title: 'messages:tooltip-copy-first-week', callback: this.onApplyFirstWeekAction, icon: 'fa fa-list-ol', },
                { id: 'duplicateData', title: 'messages:tooltip-duplicate-exercise', callback: this.onDuplicateWeeksAction, icon: 'fa fa-clone', },
            ]);

            this.view = {
                menu: new VMenu({
                    context: this,
                    radio: false,
                    collection: this.actionItems,
                    templateItem: TExerciseMenuItem,
                }),
                header: new this.headerView({ model: model })
            };

            this.listenTo(collection, {
                "update": this.onUpdate,
                "change:sets": this.onSetsChange
            });

            this.listenTo(model, {
                "change:loadEnabled": this.onLoadEnabledChange,
                "change:multiEnabled": this.onMultiRepsChange,
            });
        },

        render: function() {
            this.$el.empty().append(Mustache.render(this.template, Mustache.getContext(this.options)));

            this.generateZones()
                .toggleMultiReps()
                .applyBindings();

            this.toggleLoad();

            if (!this.options.summary) {
                this.assign(this.view.menu, this.zone.$menu);
                this.view.menu.resetTooltips(this.options.tooltip);
            }

            this.resetList();

            return this;
        },

        addAll: function(weeks) {
            var collection = weeks || this.collection.toArray(),
                item = this.options.item,
                container = document.createDocumentFragment(),
                chunkSize = 4;

            if (item && collection.length) {
                collection = [collection[item.get('week')]];
            }

            _.each(collection, function(model) {
                container.appendChild(this.addWeek(model, false));
            }, this);

            this.zone.$list.append(container);

            // if (collection.length > chunkSize) {
            //     _.defer(this.addAll.bind(this), _.rest(collection, chunkSize));
            // }
        },

        addWeek: function(model, render) {
            var view = new this.weekView({
                model: model,
                index: this.collection.indexOf(model) + 1
            });
            this.childViews.push(view);
            view.render();

            // early return the content
            if (render !== false) {
                // render now
                this.zone.$list.append(view.el);
            }

            return view.el;
        },

        resetList: function() {
            // render the table header
            this.zone.$list.empty().append(this.view.header.render().el);
            this.removeChildViews({ defer: true });
            this.addAll();
            // _.defer(this.addAll.bind(this));
        },

        toggleLoad: function(value) {
            if (_.isUndefined(value)) value = this.model.hasLoadData() || this.model.hasLoadEnabled();
            this.zone.$list.toggleClass('hide-load', !value);
            this.actionItems.get("loadEnabled").trigger("toggle:active", value);
            return this;
        },

        toggleMultiReps: function(value) {
            if (_.isUndefined(value)) value = this.model.hasMultiRep();
            this.actionItems.get("multiReps").trigger("toggle:active", value);
            return this;
        },

        /////////////
        // Actions //
        /////////////
        onActionClick: function(e) {
            e.preventDefault();
        },

        onToggleNoteAction: function() {
            this.model.trigger('toggle:note');
        },

        onConvertToCardioAction: function() {

        },

        onToggleMultiRepsAction: function() {
            this.model.toggleMultiReps();
        },

        onToggleLoadColumnAction: function() {
            this.model.toggleLoad();
        },

        onApplyFirstWeekAction: function() {
            this.model.applyFirstWeek();
            this.model.trigger('change');
        },
        onDuplicateWeeksAction: function() {
            this.model.trigger("exercise:duplicate", this.model);
        },

        ////////////
        // events //
        ////////////
        onLoadEnabledChange: function(model, value, options) {
            this.toggleLoad(value);
        },

        onMultiRepsChange: function(model, value, options) {
            this.toggleMultiReps(value);
        },

        onUpdate: function(collection, options) {
            var added = options.changes.added;
            if (added) {
                this.addAll(added);
                // _.defer(this.addAll.bind(this), added);
            }
        },

        onSetsChange: function() {
            this.model.trigger('change:sets');
        },

    });

    return VWeightExerciseContent;

});

